import { useOutfitterListingsQuery } from "~graphql/generated/graphql"

export default function useOutfitterListings({
    outfitterId,
}: {
    outfitterId: string
}) {
    const {
        data,
        loading: isLoading,
        error,
    } = useOutfitterListingsQuery({
        variables: { id: outfitterId },
    })
    const listings = data?.outfitter.listings ?? []

    return { listings, isLoading, error }
}
